import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const LocationResultItem = ({ job }) => {
  return (
    <Fragment>
      <div className="job-location-results">
        <Link to="/jobs">
          <div className="profile-drop-container">
            <i className="fas fa-location-arrow fa-lg drop-down-icon green"></i>
            <p className="drop-down-text">
              {job.location && job.location.city},{" "}
              {job.location && job.location.state}
            </p>
          </div>
        </Link>
      </div>
    </Fragment>
  );
};

export default LocationResultItem;
